import React, {FC} from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {IconButton} from '../../../../libs/shared/ui/src/components/buttons/iconButton';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {useAppSelector} from '../../../helpers/reduxHelpers';
import {SettingsDevelopersPagesEnum, SettingsDevelopersUrl} from '../../../models/url/settingsUrlModel';
import {getIsSettingsLocalApplicationLoading} from '../../../store/panels/settings/settingsPanelSelectors';

/*
 * Props.
 */

interface SettingsDevelopersHeaderInfoButtonProps {
  url: SettingsDevelopersUrl;
  isInfoBoxExpanded: boolean;
  infoBoxKey?: string;
  onToggleInfoBox: HandlerOf<string>;
}

/*
 * Component.
 */

export const SettingsDevelopersHeaderInfoButton: FC<SettingsDevelopersHeaderInfoButtonProps> = (props) => {
  const {url, isInfoBoxExpanded, infoBoxKey, onToggleInfoBox} = props;
  const theme = useUserTheme();
  const isApplicationLoading = useAppSelector(getIsSettingsLocalApplicationLoading);

  if (!infoBoxKey) {
    return null;
  }
  // If we are in a specific application and it is currently loading.
  if (
    isApplicationLoading &&
    url.subPage !== SettingsDevelopersPagesEnum.APPLICATIONS &&
    url.subPage !== SettingsDevelopersPagesEnum.TOKENS
  ) {
    return null;
  }
  return (
    <IconButton
      iconName="info"
      label={null}
      onClick={() => onToggleInfoBox(infoBoxKey)}
      isActive
      color={theme.greys.shade70}
      activeColor={theme.greys.shade70}
      hoverColor={theme.greys.shade70}
      hoverActiveColor={theme.greys.shade70}
      backgroundColor={isInfoBoxExpanded ? theme.greys.shade30 : undefined}
      backgroundHoverColor={isInfoBoxExpanded ? theme.greys.shade40 : theme.greys.shade30}
      isTooltipDisabled
    />
  );
};
